import { useEffect, useRef, useState } from "react";

// import Spinner from boostrap
import Spinner from "react-bootstrap/Spinner";

import emailjs from "@emailjs/browser";

import {
  Box,
  Button,
  Input,
  FormControl,
  FormLabel,
  FormHelperText,
  Checkbox,
  Flex,
  Icon,
  Text,
  useColorModeValue,
  VStack,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { ArrowForwardIcon } from "@chakra-ui/icons";

const MyForm = () => {
  const form = useRef();
  // stato messaggio successo ed errore
  const [limitSending, setLimitSending] = useState(false);
  const [wasSent, setWasSent] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [err, setErr] = useState(false);
  const [errMessage, setErrMessage] = useState("");
  const [status, setStatus] = useState("Submit");
  const [honeypot, setHoneypot] = useState("");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");

  // Colori per dark mode
  const bgColor = useColorModeValue("gray.900", "gray.800");
  const cardBg = useColorModeValue("gray.800", "gray.700");
  const textColor = useColorModeValue("gray.100", "gray.200");
  const secondaryTextColor = useColorModeValue("gray.300", "gray.400");
  const borderColor = useColorModeValue("gray.700", "gray.600");
  const accentColor = useColorModeValue("orange.400", "orange.300");

  useEffect(() => {
    const lastSent = localStorage.getItem("lastSentEmail");
    if (lastSent && Date.now() - parseInt(lastSent) < 30000) {
      setLimitSending(true);
      const timeout = setTimeout(
        () => setLimitSending(false),
        30000 - (Date.now() - lastSent),
      );
      return () => clearTimeout(timeout);
    }
  }, []);

  // funzione di emailjs per gestire l'invio delle mail
  const sendEmail = (e) => {
    e.preventDefault();

    const lastSent = localStorage.getItem("lastSentEmail");
    const now = Date.now();

    if (
      honeypot ||
      !name ||
      !email ||
      !message ||
      limitSending ||
      (lastSent && now - lastSent < 30000)
    ) {
      setLimitSending(true);
      return;
    }

    setStatus("Sending...");
    setWasSent(true);
    setLimitSending(true);

    emailjs
      .sendForm(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID,
        form.current,
        process.env.REACT_APP_EMAILJS_PUBLICKEY,
      )
      .then(() => {
        setErr(false);
        setWasSent(true);
        setStatus("Submit");
        e.target.reset();
        setEmail("");
        setName("");
        setMessage("");
        setIsChecked(false);
        localStorage.setItem("lastSentEmail", Date.now());
      })
      .catch((error) => {
        setWasSent(false);
        setErr(true);
        setErrMessage(error.text || "Errore durante l'invio");
      })
      .finally(() => {
        setStatus("Submit");
        setTimeout(() => {
          setLimitSending(false);
        }, 30000);
        setTimeout(() => {
          setWasSent(false);
        }, 5000);
      });

    setIsChecked(false);
  };

  const handleHoneypot = (e) => {
    const newValue = e.target.value;
    setHoneypot(newValue);
  };

  const handleEmail = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
  };
  const handleName = (e) => {
    const newName = e.target.value;
    setName(newName);
  };
  const handleMessage = (e) => {
    const newMessage = e.target.value;
    setMessage(newMessage);
  };

  const handleCheck = () => {
    if (isChecked || limitSending) {
      setIsChecked(false);
    } else {
      setIsChecked(true);
    }
  };

  return (
    <Box as="form" width={"100%"} ref={form} onSubmit={sendEmail}>
      <VStack spacing={5}>
        {/* EMAIL */}
        <FormControl isRequired>
          <FormLabel color={textColor}>Email *</FormLabel>
          <Input
            borderColor={borderColor}
            bg="gray.900"
            color={textColor}
            _hover={{ borderColor: accentColor }}
            _focus={{
              borderColor: accentColor,
              boxShadow: `0 0 0 1px ${accentColor}`,
            }}
            type="email"
            onChange={handleEmail}
            name="user_email"
            placeholder="tua@email.com"
            required
          />
          <FormHelperText
            mb={{ base: "0.5em" }}
            color={"rgba(255,255,255,0.6)"}
          >
            Non condividiamo mai la tua email con terze parti.
          </FormHelperText>
        </FormControl>
        {/* NOME */}
        <FormControl isRequired>
          <FormLabel color={textColor}>Nome *</FormLabel>
          <Input
            borderColor={borderColor}
            bg="gray.900"
            color={textColor}
            _hover={{ borderColor: accentColor }}
            _focus={{
              borderColor: accentColor,
              boxShadow: `0 0 0 1px ${accentColor}`,
            }}
            type="text"
            name="user_name"
            onChange={handleName}
            placeholder="Il tuo nome"
            required
          />
        </FormControl>
        {/* MESSAGGIO */}
        <FormControl isRequired>
          <FormLabel color={textColor}>Messaggio *</FormLabel>
          <Input
            rows={6}
            borderColor={borderColor}
            bg="gray.900"
            color={textColor}
            _hover={{ borderColor: accentColor }}
            _focus={{
              borderColor: accentColor,
              boxShadow: `0 0 0 1px ${accentColor}`,
            }}
            type="text"
            name="message"
            onChange={handleMessage}
            placeholder="Descrivi il tuo evento o le tue esigenze..."
            required
          />
        </FormControl>

        <FormControl hidden>
          <FormLabel color={textColor}>Azienda *</FormLabel>
          <Input
            borderColor={"ambra"}
            focusBorderColor="ambraHover"
            _hover={{ borderColor: "ambraHover" }}
            type="text"
            name="azienda"
            value={honeypot}
            onChange={handleHoneypot}
            placeholder="Azienda"
            autoComplete="off"
          />
        </FormControl>

        <FormControl isRequired>
          <Flex>
            <Checkbox
              isDisabled={limitSending ? true : false}
              onChange={handleCheck}
            ></Checkbox>
            <FormHelperText
              ml={{ base: "1em", xl: "0.5em" }}
              mb={{ base: "0.5em" }}
              color={"rgba(255,255,255,0.8)"}
            >
              Ho letto e accetto la{" "}
              <Box as="span" _hover={{ color: "orange.500" }}>
                <Link to="/info">Privacy Policy e i Termini e Condizioni</Link>
                <Icon
                  m={{
                    base: "0.1em 0 0 0.3em",
                  }}
                  viewBox="0 0 24 24"
                >
                  {" "}
                  {/* TODO: RISOLVI PROBLE COLORE */}
                  <path
                    d="M15.7285 3.88396C17.1629 2.44407 19.2609 2.41383 20.4224 3.57981C21.586 4.74798 21.5547 6.85922 20.1194 8.30009L17.6956 10.7333C17.4033 11.0268 17.4042 11.5017 17.6976 11.794C17.9911 12.0863 18.466 12.0854 18.7583 11.7919L21.1821 9.35869C23.0934 7.43998 23.3334 4.37665 21.4851 2.5212C19.6346 0.663551 16.5781 0.905664 14.6658 2.82536L9.81817 7.69182C7.90688 9.61053 7.66692 12.6739 9.51519 14.5293C9.80751 14.8228 10.2824 14.8237 10.5758 14.5314C10.8693 14.2391 10.8702 13.7642 10.5779 13.4707C9.41425 12.3026 9.44559 10.1913 10.8809 8.75042L15.7285 3.88396Z"
                    fill="rgba(255,191,0, 0.5)"
                  />
                  <path
                    d="M14.4851 9.47074C14.1928 9.17728 13.7179 9.17636 13.4244 9.46868C13.131 9.76101 13.1301 10.2359 13.4224 10.5293C14.586 11.6975 14.5547 13.8087 13.1194 15.2496L8.27178 20.1161C6.83745 21.556 4.73937 21.5863 3.57791 20.4203C2.41424 19.2521 2.44559 17.1408 3.88089 15.6999L6.30473 13.2667C6.59706 12.9732 6.59614 12.4984 6.30268 12.206C6.00922 11.9137 5.53434 11.9146 5.24202 12.2081L2.81818 14.6413C0.906876 16.5601 0.666916 19.6234 2.51519 21.4789C4.36567 23.3365 7.42221 23.0944 9.33449 21.1747L14.1821 16.3082C16.0934 14.3895 16.3334 11.3262 14.4851 9.47074Z"
                    fill="rgba(255,191,0, 0.5)"
                  />
                </Icon>
              </Box>
              . *
            </FormHelperText>
          </Flex>
          {/* Gestione del messaggio di successo o errore */}
          {wasSent === true ? (
            <FormHelperText className="text-light">
              {err === true
                ? `Errore di connessione ${errMessage}`
                : "Messaggio inviato con successo"}
            </FormHelperText>
          ) : null}
        </FormControl>

        {limitSending && <Text>Il form è disabilitato per 30 secondi</Text>}
        {/* Gestione dello spinner per il caricamento */}
        {status === "Sending..." ? (
          <Spinner animation="grow" />
        ) : (
          <Button
            isDisabled={isChecked ? false : true || status === "Sending..."}
            type="submit"
            id="submit"
            colorScheme="orange"
            size="lg"
            width="100%"
            bg="linear-gradient(135deg, #FFB300 0%, #FF8F00 100%)"
            _hover={{
              transform: "translateY(-2px)",
              boxShadow: "dark-lg",
            }}
            transition="all 0.3s"
            loadingText="Invio in corso..."
            rightIcon={<ArrowForwardIcon />}
          >
            {status}
          </Button>
        )}
        <Text color={secondaryTextColor} fontSize="sm" textAlign="center">
          Ti risponderemo il prima possibile.
        </Text>
      </VStack>
    </Box>
  );
};

export default MyForm;
